import { DvmModule, Viewer3dService } from '@3ddv/ngx-dvm-internal';
import { Component, inject, Signal } from '@angular/core';
import { DvmService } from '@services/dvm.service';

@Component({
    selector: 'app-viewer3d',
    imports: [
        DvmModule
    ],
    templateUrl: './viewer3d.component.html',
    styleUrl: './viewer3d.component.css'
})
export class Viewer3dComponent {

  // SERVICES
  private readonly dvm:        DvmService      = inject(DvmService);

  // GLOBAL STATE
  public  readonly viewer3d:   Viewer3dService = this.dvm.viewer3d; // Viewer3D Service
  public  readonly showViewer: Signal<boolean> = this.dvm.is3d; // Show Viewer Signal

}
